import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getSurveysCampaignsCall,
  postSurveysCampaignsCall,
  putSurveyCampaignByIdCall,
  getSurveyCampaignByIdCall,
  getTemplatesCall,
  getTemplateByIdCall,
  postTemplateSimulateCall,
  getSurveyCampaignInvitationByTemplateIdCall,
  postSurveysCampaignByIdReminderCall,
  getSurveyCampaignByIdResponsesStatsCall,
  getSurveyCampaignByIdResponsesResultsStatsCall,
  getEmployerNotCompletedSurveysCall,
  postEmployerByIdSurveyResultCall,
  postSurveysCampaignByIdNextCall,
  postSurveysCampaignByIdEndCall,
  putSurveyCampaignVisibilityCall,
  getSurveyCampaignsResultsStatsCall,
  getSurveysCampaignByIdReminderEmployeesCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getSurveysCampaignsCall.saga,
  postSurveysCampaignsCall.saga,
  putSurveyCampaignByIdCall.saga,
  getSurveyCampaignByIdCall.saga,
  getTemplatesCall.saga,
  getTemplateByIdCall.saga,
  getSurveyCampaignInvitationByTemplateIdCall.saga,
  postSurveysCampaignByIdReminderCall.saga,
  getSurveyCampaignByIdResponsesStatsCall.saga,
  getSurveyCampaignByIdResponsesResultsStatsCall.saga,
  getEmployerNotCompletedSurveysCall.saga,
  postEmployerByIdSurveyResultCall.saga,
  postSurveysCampaignByIdNextCall.saga,
  postSurveysCampaignByIdEndCall.saga,
  putSurveyCampaignVisibilityCall.saga,
  getSurveyCampaignsResultsStatsCall.saga,
  postTemplateSimulateCall.saga,
  getSurveysCampaignByIdReminderEmployeesCall.saga,
];

export function* surveysRootSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
